import { Observable } from "rxjs";
import { EnvioCorreoDraftRequest, getCorreoHistoricoRequest } from "./domain/gestion-correos.request";
import { D_CorreoHistoricoResponse, D_SendCorreoDraftResponse } from "./domain/gestion-correos.response";

export abstract class GestionCorreosRepository {

  abstract obtenerCorreoHistorico(request: getCorreoHistoricoRequest): Observable<D_CorreoHistoricoResponse>;
  abstract envioCorreoDraft(request: EnvioCorreoDraftRequest): Observable<D_SendCorreoDraftResponse>;

}
